import React, { useState } from 'react';
import { US_TYPES, usDefaults, usGenerate, usDescribe } from '../usCodegen';

export default function USCodeGenerator({ initialType, onApply, onClose }) {
  const [typeKey, setTypeKey] = useState(initialType || 'downlight');
  const [sel, setSel] = useState(() => usDefaults(initialType || 'downlight'));
  const t = US_TYPES[typeKey];
  const code = usGenerate(typeKey, sel);

  function switchType(k) { setTypeKey(k); setSel(usDefaults(k)); }

  return (
    <div className="uscg-overlay" data-testid="uscg-overlay">
      <div className="uscg-panel">
        <div className="uscg-head">
          <strong>US Smart Code Builder</strong>
          <button className="btn btn-sm" data-testid="uscg-close" onClick={onClose}>✕ Close</button>
        </div>
        <div className="uscg-types">
          {Object.entries(US_TYPES).map(([k, v]) => (
            <button key={k} className={'uscg-type' + (typeKey === k ? ' on' : '')} data-testid={'uscg-type-' + k}
              onClick={() => switchType(k)}>{v.label}</button>
          ))}
        </div>
        <div className="uscg-template">Template: <code>{t.template}</code> · e.g. <code>{t.example}</code></div>
        <div className="uscg-grid">
          {t.fields.map(f => (
            <label key={f.key} className="uscg-field">
              <span>{f.label}</span>
              <select className="input" data-testid={'uscg-f-' + f.key} value={sel[f.key] || ''}
                onChange={e => setSel(s => ({ ...s, [f.key]: e.target.value }))}>
                {f.optional && <option value="">— omit —</option>}
                {f.options.map(o => <option key={o.code} value={o.code}>{o.label} ({o.code})</option>)}
              </select>
            </label>
          ))}
        </div>
        <div className="uscg-result">
          <div className="uscg-code" data-testid="uscg-code">{code}</div>
          <button className="btn btn-primary" data-testid="uscg-apply" onClick={() => {
            onApply({ code, typeKey, sel, decoded: usDescribe(typeKey, sel) });
            onClose();
          }}>Apply to datasheet</button>
        </div>
      </div>
    </div>
  );
}
